import React from 'react';
import PropTypes from 'prop-types';
import { useUser } from '@lore/auth';
import { useConnect } from '@lore/query-connect';
import ConnectButton from './ConnectButton';
import { PayloadStates } from '@lore/utils';
import Wrapper from './Wrapper';
import useDialogLauncher from '@/dialogs-routable/_hooks/useDialogLauncher';
import { DialogManager } from '@/dialogs_new/DialogManager';

ProjectBanner.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
  project: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired
};

export default function ProjectBanner(props) {
  const {
    user,
    project
  } = props;

  const currentUser = useUser();
  const launch = useDialogLauncher();

  const questions = useConnect('question.find', {
    where: {
      eager: {
        $where: {
          userId: user.id,
          projectId: project.id,
          request: { $not: 'Outreach' }
        }
      }
    }
  });

  function showInviteDialog() {
    launch(DialogManager.QuestionInvite.Config(project.id, user.id));
  }

  if (questions.state === PayloadStates.FETCHING) {
    return (
      <Wrapper user={user}>
        <ConnectButton disabled={true}>
          ...
        </ConnectButton>
      </Wrapper>
    );
  }

  if (user.id === currentUser.id) {
    return (
      <Wrapper user={user}>
        <ConnectButton disabled={true}>
          This is you
        </ConnectButton>
      </Wrapper>
    );
  }

  if (questions.data.length > 0) {
    return (
      <Wrapper user={user}>
        <ConnectButton disabled={true}>
          Connected
        </ConnectButton>
      </Wrapper>
    );
  }

  return (
    <Wrapper user={user}>
      <ConnectButton onClick={showInviteDialog}>
        Connect
      </ConnectButton>
    </Wrapper>
  );
};
